import { Entry } from '../Entry/Entry';
import './TableEntry.scss';

export const TableEntry = ({ entry }) => {
    const { colLabels, colStyles, rows } = entry;

    const colTemplate = () => {
        const colPattern = /col-(\d+)/;
        return colStyles.map(cs => (
            `${Math.ceil(parseInt(cs.match(colPattern)[1]) / 4)}fr`
        )).join(' ');
    };
console.log(rows);
    return (
        <div 
            className="TableEntry"
            style={{
                gridTemplateColumns: colTemplate()
            }}
        >
            {colLabels.map((label, i) => (
                <Entry key={`colLabel${i}`} entry={label} />
            ))}

            {rows.map((row, r) => (
                row.map((text, i) => (
                    <Entry  key={`tableitem${r}${i}`} entry={text} />
                ))
            ))}
        </div>
    );
};